/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
// import { Dimensions } from 'react-native';
import { t } from 'i18next';

import hotelmap from '../../images/hotel_map.svg'
import hotelmap_en from '../../images/hotel_map_en.svg'

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';


const HotelMap = () => {    
    return(
        <div className="sect-01-box-01-hotel">
            <div className="sect-tit">{t("hotel_map_title")}</div>
            <div className='hotel-map-img-box-wrap'>
                <div className='hotel-map-img-box'>
                    {t("lang") === 'ko'
                    ? <img src={hotelmap}/>
                    : <img src={hotelmap_en}/>}
                </div>
            </div>
        </div>
    )
}

export default HotelMap;